import { DRIFT_CHAT_BIONIC_MESSAGES_KEYWORDS_DIMENSIONS } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const AIInsightsKeywordsQuery: CubeQuery = {
  name: 'DriftChatBionicMessageKeywords',
  query: {
    order: {
      [DRIFT_CHAT_BIONIC_MESSAGES_KEYWORDS_DIMENSIONS.MESSAGE_COUNT]: 'desc',
    },
  },
  queryName: 'DriftChatBionicMessageKeywords',
}
